import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { CursorPosition, MinWriterMenuComponent } from './min-writer-menu/min-writer-menu.component';
import { Router } from '@angular/router';
import { EntryApi } from '../../data/entry/entry.api';
import dayjs from 'dayjs';
import { dateFormat } from '../../tools/date';
import { Tables, TablesInsert } from '../../data/database.types';
import { DayService } from '../../data/day/day.service';
import { Topic } from '../../data/topic/topic';

@Component({
  selector: 'app-min-writer',
  templateUrl: './min-writer.component.html',
  styleUrls: ['./min-writer.component.scss'],
  providers: [DayService]
})
export class MinWriterComponent implements OnInit {
  private router = inject(Router);
  private modalController = inject(ModalController);
  private toastController = inject(ToastController);
  private entryApi = inject(EntryApi);

  private dayService = inject(DayService);

  @ViewChild('textAreaElement') textArea?: ElementRef<HTMLTextAreaElement>;

  lastMenuCursorPosition?: CursorPosition;

  pinFormatter = (x: number) => x * 10;


  // text = ''
//   text = `
// Ich glaube mein Schlaf wird langsam besser! Heute bin ich so um 8 aus dem Bett gekommen und bin auch relativ zügig rausgegangen!
//
// Was soll ich noch schreiben und nicht lügen? Jetzt ist es noch gar nicht so spät und ich bin schon ganz schön müde. Aber hinlegen will ich mich auch noch nicht. Doch wie mache ich jetzt hier weiter?
// `

  date = dayjs().format(dateFormat);
  topic?: Topic;
  entry?: TablesInsert<'entries'>;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!this.menu) {
      switch (event.key) {
        case 'Escape':
          this.save();
          this.showMenu();
      }
    }
  }

  menu: HTMLIonModalElement | null = null

  constructor() {
  }

  async ngOnInit() {
    await this.entryApi.fetchEntriesByDate(this.date);
    this.showMenu();
  }

  ngAfterViewInit() {
    console.log(this.textArea);
    setTimeout(() => {
      console.log(this.textArea?.nativeElement?.value);
      const el = this.textArea?.nativeElement;
      if (el) {
        // console.log((el.parentNode as any)['dataset'])
        (el.parentNode as any).dataset.replicatedValue = el.value;
        setTimeout(() => {
          el.focus();
        }, 20)
      }

    })
  }

  onInput(ev: any) {
    // console.log(ev);
    const el = ev.target;
    el.parentNode.dataset.replicatedValue = el.value;
  }

  refreshInput() {
    const el: any = this.textArea?.nativeElement;
    if (el) {
      el.parentNode.dataset.replicatedValue = el.value;
    }
  }

  async showMenu() {
    this.menu = await this.modalController.create({
      component: MinWriterMenuComponent,
      componentProps: {
        dayService: this.dayService,
        lastCursorPosition: this.lastMenuCursorPosition
      }
    });
    this.menu.onDidDismiss().then(response => {
      this.menu = null;
      console.log(response)

      if (response.role === 'select') {
        const {vm, cursorPosition} = response.data;
        this.lastMenuCursorPosition = cursorPosition;
        if (vm) {
          console.log(vm);
          this.topic = vm.topic;
          if (vm.entry) {
            this.entry = vm.entry;
          } else {
            this.entry = {
              date: this.date,
              topic_id: vm.topic.id,
              content: ''
            }
          }
          setTimeout(() => {
            this.refreshInput();
            this.textArea?.nativeElement.focus()
          });
        }
      } else if (response.role === 'exit') {
        this.router.navigate(['topics'])
      }

    });
    await this.menu.present();
  }

  private async save() {
    if (this.entry) {
      await this.entryApi.upsert(this.entry);
      this.entry = undefined;
      const toast = await this.toastController.create({
        message: 'Entry was saved.',
        duration: 1000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  updateValue(ev: any) {
    this.entry = {
      ...this.entry!,
      value: ev.detail.value
    }
  }
}
